import React from 'react';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments, faTimes, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import Axios from '../../apis/nodeServer';
import './assistant.css';

const WELCOME_MESSAGE = 'Oi! Me diga o que você quer fazer, por exemplo "mapa de risco" ou "adicionar amostra", que eu te levo até lá.';

class Assistant extends React.Component {
    state = {
        isOpen: false,
        query: '',
        sending: false,
        messages: [{ from: 'assistant', text: WELCOME_MESSAGE }],
    };

    toggleOpen = () => {
        this.setState((prev) => ({ isOpen: !prev.isOpen }));
    };

    handleChange = (event) => {
        this.setState({ query: event.target.value });
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        const query = this.state.query.trim();
        if (!query || this.state.sending) {
            return;
        }

        this.setState((prev) => ({
            messages: [...prev.messages, { from: 'user', text: query }],
            query: '',
            sending: true,
        }));

        try {
            const response = await Axios.instance.post('assistant/query/', { query });
            const data = response.data;

            this.setState((prev) => ({
                messages: [...prev.messages, { from: 'assistant', text: data.message }],
                sending: false,
            }));

            if (data.type === 'navigate' && data.target) {
                setTimeout(() => this.props.history.push(data.target), 400);
            }
        } catch (error) {
            this.setState((prev) => ({
                messages: [...prev.messages, { from: 'assistant', text: 'Não consegui falar com o servidor agora. Tenta de novo em instantes.' }],
                sending: false,
            }));
        }
    };

    render() {
        const { isOpen, query, sending, messages } = this.state;

        return (
            <div className="assistant-widget">
                {isOpen && (
                    <div className="assistant-panel">
                        <div className="assistant-panel-header">
                            <span>Assistente</span>
                            <FontAwesomeIcon icon={faTimes} className="assistant-close-icon" onClick={this.toggleOpen} />
                        </div>
                        <div className="assistant-panel-body">
                            {messages.map((message, index) => (
                                <div key={index} className={`assistant-bubble assistant-bubble-${message.from}`}>
                                    {message.text}
                                </div>
                            ))}
                            {sending && (
                                <div className="assistant-bubble assistant-bubble-assistant assistant-bubble-loading">
                                    Pensando...
                                </div>
                            )}
                        </div>
                        <form className="assistant-panel-footer" onSubmit={this.handleSubmit}>
                            <input
                                type="text"
                                className="assistant-input"
                                placeholder="O que você quer fazer?"
                                value={query}
                                onChange={this.handleChange}
                                disabled={sending}
                            />
                            <button type="submit" className="assistant-send-button" disabled={sending || !query.trim()}>
                                <FontAwesomeIcon icon={faPaperPlane} />
                            </button>
                        </form>
                    </div>
                )}
                <button className="assistant-fab" onClick={this.toggleOpen} title="Assistente">
                    <FontAwesomeIcon icon={isOpen ? faTimes : faComments} />
                </button>
            </div>
        );
    }
}

export default withRouter(Assistant);
